import dedent from 'dedent';

export const termsOfServiceDef = {
  text: dedent`Last Updated: December 7, 2025
Terms of Services
Please read and understand our Terms of Service carefully before using our Services.

What These Terms Mean in Plain English

i. Waterlily is a Tool, Not an Advisor: We provide the technology, math, and models to help you and your professional plan for long-term care. We do not provide medical, financial, or legal advice.

ii. Work with a Pro: We strongly recommend using Waterlily under the guidance of a qualified professional (financial advisor, insurance agent, etc.).

iii. You Are in Control: We only share your data with carriers when you ask us to.

iv. Estimates, Not Guarantees: Our AI projections are estimates based on data. You and your advisor are responsible for verifying details before buying policies.

1. Acceptance of Terms
By accessing or using Waterlily’s eldercare planning services (the “Services”), you agree to comply with and be bound by these Terms of Service (“Terms”) and our Privacy Policy. These Terms apply to you and anyone you’ve authorized—including your financial advisor, insurance agent, or other professional ("Professional")—to use the Services on your behalf.


2. Ownership and Limited License
The Services, including all text, graphics, AI models, and content, are owned by Waterlily or our licensors. You are granted a limited, nonexclusive, nontransferable, revocable license to access and use our Services as permitted under these Terms.


3. Trademarks
The Waterlily name, logos, and look and feel are trademarks of Waterlily and may not be used without prior written permission.


4. Feedback
Any feedback you provide regarding the Services is voluntary. You grant Waterlily a license to use, reproduce, and incorporate your feedback into the Services.


5. Personal Information & Professional Access
Waterlily will process personal information as necessary to provide the Services. If you invite a Professional to view your account, or if a Professional creates an account on your behalf, you acknowledge that they will have access to your personal and financial data. Waterlily is not responsible for how your Professional uses your data outside of the Waterlily platform.


6. Restrictions
i. You shall not:

Decompile, reverse engineer, or attempt to derive the source code of the Services.

Use the Services for any unlawful purpose.


ii. Acknowledgment of Non-Responsibility:

You acknowledge that Waterlily does not undertake and is not responsible for any insurance or financial product recommendations that might be made to consumers. You release Waterlily from any actual or alleged liability related to insurance or financial product recommendations directed to any consumer or purchaser of a financial or insurance product, regardless of whether Waterlily products are used in making any such recommendation.


7. Nature of Services & No Professional Advice
Waterlily is a technology provider, not a financial, medical, or legal advisor.

The Services, including our AI models, health projections, and financial calculations, are designed to facilitate planning discussions between you and your qualified Professional.

i. No Medical Advice: Our health projections are statistical models and do not constitute a medical diagnosis.

ii. No Financial Advice: Our financial projections are simulations and do not constitute investment advice.

Acknowledgment of Non-Responsibility:

You acknowledge that Waterlily is not responsible for any insurance or financial product recommendations made to you by your Professional or implied by the software. You release Waterlily from liability related to purchasing any financial or insurance product based on our platform's models.


8. Disclaimers
Waterlily strives to provide accurate modeling but provides services "as is," without warranties. You and your Professional are solely responsible for verifying extracted product information and calculations against original product documentation. Please review our Methodology sections to understand how projections are calculated.


9. Limitation of Liability
To the maximum extent permitted by law, in no event shall Waterlily be liable for any indirect, incidental, consequential, or special damages arising out of your use of the Services.


10. Indemnification
You agree to indemnify and hold harmless Waterlily from any claims arising out of your use of the Services, your violation of these Terms, or your violation of any applicable laws.


11. Compliance with Laws
You represent and warrant that you will use the Services in compliance with all applicable laws, including those related to privacy and data security.


12. Modifications & Termination
Waterlily reserves the right to modify or discontinue the Services at any time. We may terminate your access immediately if you breach these Terms. Waterlily further reserves the right, at its sole discretion, to change, modify, add or remove any portion of these Terms of Service in whole or in part, at any time without notice; you should periodically revisit this site to review the current terms and conditions by which you are bound. Changes in these Terms of Service will be effective when posted. Your continued use of the site and Services after any changes to these Terms of Service are posted will be considered acceptance of the changes.


13. Governing Law
These Terms shall be governed by the laws of the State of Nevada.


14. Data Use
You agree that Waterlily may use your data as described in our Privacy Policy to provide services, enhance and improve Waterlily services and to analyze our service offering.


15. Contact Us
If you have any questions about these Terms, please contact us at hello@joinwaterlily.com.


Last Updated
December 7th, 2025`,
  date: '2025-12-07',
  consentVersionDescription: 'Terms Of Services - Updated 7 December 2025',
};
